import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ContactCTA = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);

    // Mock form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });

      setTimeout(() => {
        setSubmitStatus(null);
      }, 3000);
    }, 2000);
  };

  const contactMethods = [
    {
      icon: "Mail",
      title: "Email",
      description: "Drop me a mail",
      value: "lokendra582809@gmail.com",
      action: "Send Email",
      color: "electric-cyan",
      link: "mailto:lokendrakumar582809@gmail.com"
    },
    {
      icon: "MessageCircle",
      title: "LinkedIn",
      description: "Let\'s connect professionally",
      value: "Lokendra Kumar",
      action: "Connect",
      color: "trust-green",
      link: "https://www.linkedin.com/in/lokendra-kumar-563a41251/"
    },
    {
      icon: "Twitter",
      title: "Twitter",
      description: "Let\'s connect socially",
      value: "@Lokendra9214",
      action: "Connect through social media",
      color: "rocket-fire",
      link: "https://x.com/Lokendra9214"
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'electric-cyan':
        return {
          bg: 'bg-electric-cyan',
          text: 'text-electric-cyan',
          hover: 'hover:bg-electric-cyan/10'
        };
      case 'trust-green':
        return {
          bg: 'bg-trust-green',
          text: 'text-trust-green',
          hover: 'hover:bg-trust-green/10'
        };
      case 'rocket-fire':
        return {
          bg: 'bg-rocket-fire',
          text: 'text-rocket-fire',
          hover: 'hover:bg-rocket-fire/10'
        };
      default:
        return {
          bg: 'bg-deep-space',
          text: 'text-deep-space',
          hover: 'hover:bg-deep-space/10'
        };
    }
  };

  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "03d17385-ac8f-4565-8b09-6a057123e9e8");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("");
      alert("Form Submitted Successfully")
      event.target.reset();
    } else {
      console.log("Error", data);
      alert(data.message);
      setResult("");
    }
  };

  return (
    <section id='contactform' className="py-20 bg-gradient-to-br from-deep-space via-slate-900 to-slate-800 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-2 h-2 bg-electric-cyan rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-trust-green rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-40 left-20 w-1.5 h-1.5 bg-rocket-fire rounded-full animate-pulse delay-500"></div>
        <div className="absolute top-60 left-1/3 w-1 h-1 bg-white rounded-full animate-pulse delay-700"></div>
        <div className="absolute bottom-60 right-1/4 w-2 h-2 bg-electric-cyan rounded-full animate-pulse delay-300"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
              <Icon name="Rocket" size={16} className="text-rocket-fire" />
              <span className="text-white text-sm font-medium">Ready for Launch</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-headline text-white mb-6 leading-tight">
              Let's Build Something{' '}
              <span className="text-transparent bg-gradient-to-r from-rocket-fire to-electric-cyan bg-clip-text">
                Amazing Together
              </span>
            </h2>

            <p className="text-xl text-slate-300 mb-8 leading-relaxed">
              Whether you're looking for a dedicated developer, have a project in mind,
              or just want to connect, I'm always excited to discuss new opportunities
              and collaborations.
            </p>

            {/* Contact Methods */}
            <div className="space-y-4 mb-8">
              {contactMethods?.map((method, index) => {
                const colors = getColorClasses(method?.color);
                return (
                  <a href={`${method.link}`}>
                    <div
                      key={index}
                      className={`flex items-center space-x-4 p-4 bg-white/5 backdrop-blur-sm rounded-lg border border-white/10 ${colors?.hover} transition-brand cursor-pointer group`}
                    >
                      <div className={`w-12 h-12 ${colors?.bg} rounded-lg flex items-center justify-center shadow-brand`}>
                        <Icon name={method?.icon} size={20} color="white" />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-white font-medium">{method?.title}</h4>
                        <p className="text-slate-400 text-sm">{method?.description}</p>
                        <p className="text-slate-300 text-sm">{method?.value}</p>
                      </div>
                      <div className={`${colors?.text} group-hover:translate-x-1 transition-brand`}>
                        <Icon name="ArrowRight" size={18} />
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>

            {/* Quick Actions */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="https://drive.google.com/file/d/1Z6dDJOKy3zWfDfeohi6FU9feCnjSGTFM/view?usp=sharing"><Button
                variant="default"
                size="lg"
                className="bg-rocket-fire hover:bg-rocket-fire/90 text-white font-cta shadow-brand-lg"
                iconName="Download"
                iconPosition="left"
              >
                Download Resume
              </Button>
              </a>

            </div>
          </div>

          {/* Right Content - Contact Form */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="mb-6">
              <h3 className="text-2xl font-value-prop text-white mb-2">
                Send a Message
              </h3>
              <p className="text-slate-300">
                Got a project in mind? Let's discuss how we can work together.
              </p>
            </div>

            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-trust-green/20 border border-trust-green/30 rounded-lg">
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={20} className="text-trust-green" />
                  <span className="text-trust-green font-medium">Message sent successfully!</span>
                </div>
                <p className="text-trust-green/80 text-sm mt-1">
                  I'll get back to you within 24 hours.
                </p>
              </div>
            )}

            <form onSubmit={onSubmit} className="space-y-6">
              <Input
                label="Full Name"
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData?.name}
                onChange={handleInputChange}
                required
                className="bg-white/5 border-white/20 text-white placeholder-slate-400"
              />

              <Input
                label="Email Address"
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData?.email}
                onChange={handleInputChange}
                required
                className="bg-white/5 border-white/20 text-white placeholder-slate-400"
              />

              <div>
                <label className="block text-white font-medium mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  rows={4}
                  placeholder="Tell me about your project or just say hello..."
                  value={formData?.message}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-rocket-fire focus:border-transparent transition-brand resize-none"
                />
              </div>

              <Button
                type="submit"
                variant="default"
                size="lg"
                fullWidth
                loading={isSubmitting}
                className="bg-rocket-fire hover:bg-rocket-fire/90 text-white font-cta shadow-brand-lg"
                iconName="Send"
                iconPosition="right"
              >
                {result ? result : 'Send Message'}
              </Button>
            </form>

            <div className="mt-6 pt-6 border-t border-white/20 text-center">
              <p className="text-slate-400 text-sm">
                Prefer a different method? Find me on social media
              </p>
              <div className="flex justify-center space-x-4 mt-3">
                {[{ icon: 'Github', link: "https://github.com/LokendraKumar8" }, { icon: 'Linkedin', link: "https://www.linkedin.com/in/lokendra-kumar-563a41251/" }, { icon: 'Twitter', link: "https://x.com/Lokendra9214" }]?.map((social, index) => (
                  <a href={`${social.link}`}>
                    <button
                      key={index}
                      className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-brand"
                    >
                      <Icon name={social.icon} size={18} className="text-white" />
                    </button>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;